/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Comparative_Literature27Inputs */

const en__field__enum_studyprograms_study_comparative_literature27 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Comparative_Literature27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparative Literature`)
};

const de__field__enum_studyprograms_study_comparative_literature27 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Comparative_Literature27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemeine und vergleichende Literaturwissenschaft`)
};

/**
* | output |
* | --- |
* | "Comparative Literature" |
*
* @param {_Field__Enum_Studyprograms_Study_Comparative_Literature27Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_comparative_literature27 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Comparative_Literature27Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Comparative_Literature27Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_comparative_literature27(inputs)
	return de__field__enum_studyprograms_study_comparative_literature27(inputs)
});
export { _field__enum_studyprograms_study_comparative_literature27 as "_field__enum_studyPrograms_STUDY_COMPARATIVE_LITERATURE" }